import { DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack } from "@fluentui/react";
import * as React from "react";
import { useContext } from "react";
import AuthContext from "../../../Services/AuthContext";

function PaymentRetentionDataView({ items, refresh }) {
    const [user] = useContext(AuthContext);
    const _deleteRetention = (item) => {
        fetch(`/api/agreement/retention/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { refresh(); })
            .catch(err => { console.log(err) })
    }

    const columns = [
        {
            key: 'name',
            name: 'Zatrzymanie',
            ariaLabel: 'Zatrzymanie',
            fieldName: 'name',
            isResizable: true,
            minWidth: 150
        },
        {
            key: 'percentage',
            name: '%',
            ariaLabel: '%',
            fieldName: 'percentage',
            maxWidth: 40
        },
        {
            key: 'delay',
            name: 'Dni',
            ariaLabel: 'Dni',
            fieldName: 'delay',
            maxWidth: 40
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 70,
            maxWidth: 70,
            onRender: (item) => (<IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteRetention(item)}/>)
        }
    ];

    return <Stack.Item grow={true}>
        <h4 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>Zatrzymania Płatności</h4>
        <DetailsList items={items} columns={columns} selectionMode={SelectionMode.none} />
    </Stack.Item>;
}

export default PaymentRetentionDataView;